import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { FilesView } from 'api/clients/FilesViewsClient'
import QueryString from 'qs'
import { SuccessResponse } from 'request-dot-js'
import { State } from 'stores/Workflows/State'
import { Workflow } from 'stores/Workflows/Workflow'

// Return states that have been deleted or that had their automation type updated
const getReassignmentCandidates = (oldWorkflow: Workflow, newWorkflow: Workflow) => {
  return oldWorkflow.states.filter((oldState) => {
    try {
      const newWorkflowState = newWorkflow.getState(oldState.key)
      return newWorkflowState.entryAction?.type !== oldState.entryAction?.type
    } catch (e) {
      // State was deleted, so needs to be reassigned
      return true
    }
  })
}

export const getStatesToReassign = async (
  oldWorkflow: Workflow,
  newWorkflow: Workflow,
  workspaceId: number,
  folderId: string,
) => {
  const statesToReassign: State[] = []
  const candidatesForReassignment = getReassignmentCandidates(oldWorkflow, newWorkflow)

  const filesChecks = await Promise.all(
    candidatesForReassignment.map((state) => {
      const filters = {
        glue: 'or',
        groups: [
          {
            glue: 'or',
            conditions: [
              {
                operand: { kind: 'property', property_id: newWorkflow.propertyId },
                operator: 'eq',
                value: state.propertyValue.id,
              },
            ],
          },
        ],
      }

      const queryString = QueryString.stringify(
        {
          page: 1,
          items: 1,
          filters,
        },
        {
          encodeValuesOnly: true,
          arrayFormat: 'brackets',
        },
      )

      return sendToApi<FilesView>(`/w/${workspaceId}/files_views/${folderId}?${queryString}`)
    }),
  )

  if (filesChecks.some((response) => response.type !== SUCCESS_RESPONSE_TYPE)) {
    throw new Error()
  }
  ;(filesChecks as SuccessResponse[]).forEach((response, i) => {
    if (Number(response.headers['total-count']) > 0) {
      statesToReassign.push(candidatesForReassignment[i])
    }
  })

  return statesToReassign
}
